<p-dialog [visible]="true" [modal]="true" [draggable]="false" [resizable]="false"
  styleClass="!rounded-[2rem] overflow-hidden shadow-2xl" contentStyleClass="!p-0" (onHide)="close.emit()"
  [style]="{ width: '640px' }" [breakpoints]="{ '720px': '92vw' }">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full pr-8">
      <div class="flex flex-col gap-0.5">
        <h3 class="text-xl font-bold text-slate-800">{{ 'DTP_LINK_DIAGNOSIS' | translate }}</h3>
        <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          {{ providerDiagnostic?.name }}
        </p>
      </div>
    </div>
  </ng-template>

  <div class="flex flex-col h-[560px] max-h-[85vh]">
    <div class="flex flex-col gap-4 p-8 pt-4 flex-1 overflow-hidden">
      <p class="text-xs text-slate-500 leading-relaxed">
        {{ 'DTP_LINK_DIAGNOSIS_HINT' | translate }}
      </p>

      <div class="flex flex-col gap-2">
        <label class="text-xs font-black text-slate-400 uppercase tracking-widest ml-1">
          {{ 'common_search' | translate }}
        </label>
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
          <input pInputText [formControl]="searchControl" type="text"
            class="!w-full !rounded-2xl !bg-slate-50/50 !border-slate-100 !pl-12 !py-3 !text-sm focus:!ring-primary/10 focus:!border-primary transition-all shadow-sm"
            [placeholder]="'common_search' | translate" />
        </p-iconField>
      </div>

      <div class="flex-1 overflow-y-auto custom-scrollbar border border-slate-100 rounded-[2rem] bg-white p-2">
        <div *ngIf="loading" class="flex flex-col gap-3 p-2">
          <div *ngFor="let i of [1,2,3,4,5]" class="h-14 bg-slate-50 animate-pulse rounded-2xl w-full"></div>
        </div>

        <div *ngIf="!loading && visible.length === 0"
          class="flex flex-col items-center justify-center py-20 text-slate-400 gap-4">
          <div class="w-16 h-16 rounded-[2rem] bg-slate-50 flex items-center justify-center">
            <i class="pi pi-search text-2xl opacity-40"></i>
          </div>
          <span class="text-xs font-bold uppercase tracking-widest">{{ 'no_items_added' | translate }}</span>
        </div>

        <div *ngFor="let d of visible" (click)="pick(d)"
          class="px-5 py-4 flex items-center justify-between cursor-pointer rounded-2xl transition-all duration-200 mb-1 group"
          [class.bg-primary/5]="selectedId === d.id" [class.hover:bg-slate-50]="selectedId !== d.id">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-xl flex items-center justify-center transition-all"
              [ngClass]="selectedId === d.id ? 'bg-primary text-white' : 'bg-primary/5 text-primary'">
              <i class="pi text-[10px]" [ngClass]="selectedId === d.id ? 'pi-check' : 'pi-link'"></i>
            </div>
            <span class="text-sm font-bold"
              [ngClass]="selectedId === d.id ? 'text-primary' : 'text-slate-700'">{{ d.name }}</span>
          </div>
          <span *ngIf="currentMasterId === d.id"
            class="text-[9px] font-black uppercase tracking-widest text-slate-400">
            {{ 'DTP_LINK_CURRENT' | translate }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between gap-3 px-8 py-5 border-t border-slate-100 bg-slate-50/50">
      <app-button *ngIf="currentMasterId" variant="ghost" [label]="'DTP_UNLINK' | translate" icon="pi pi-times"
        [loading]="saving" (onClick)="unlink()"></app-button>
      <span *ngIf="!currentMasterId"></span>

      <div class="flex items-center gap-3">
        <app-button variant="ghost" [label]="'CANCEL' | translate" (onClick)="close.emit()"></app-button>
        <app-button [label]="'SAVE' | translate" icon="pi pi-check" [loading]="saving"
          [disabled]="!selectedId || selectedId === currentMasterId" (onClick)="save()"></app-button>
      </div>
    </div>
  </div>
</p-dialog>
